import React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Field, useField, useForm } from 'react-final-form';
import Select from '../../Forms/select';
import Message from '../../Forms/message';
import { getLocations } from '../../../services/uploadingService';
import { FormWrapper, FormSection, SectionLabel, Content } from '../Wizard/common';
import Input from '../../Forms/input';
import TextArea from '../../Forms/textarea';
import CheckBox from '../../Forms/checkbox';
import DatePicker from '../../Forms/datepicker';
import { InputWrapper } from '../../Forms/common';
import Loading from '../../Loading';

const FullWidthSection = styled(FormSection)`

  ${CheckBox}:not(:last-child) {
    margin-bottom: 16px;
  }

  @media screen and (min-width: 768px) {
    grid-column: span 2;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 2rem 1rem;
`;

function UploadingDrone() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  const { change } = useForm();

  const {
    input: { value: selectedType },
  } = useField(`uploadType`, {
    subscription: { value: true },
  });

  // TODO
  // - load data in parent component??
  // - handle loading/error state
  useEffect(() => {
    getLocations()
      .then(data => {
        if(data){
          if(selectedType ==="forest"){
            setLocations(data.filter(({type}) => ["forestRGB","forestMulti"].includes(type)))
            return;
          }
          setLocations(data.filter(({type}) => type === selectedType))}
        }
      )
      .then(() => setLoading(false));

  }, []);

  if(loading) {
    return (
      <InfoWrapper>
        <Loading message="Loading data..." />
      </InfoWrapper>
    );
  }
  return (

  <FormWrapper>
    <FormSection>
      <SectionLabel>Project Information</SectionLabel>
      <Content>
        <Field name="projectName">
          {({ input, meta }) => (
            <InputWrapper>
              <label>Project name</label>
              <Input type="text" placeholder="Anjalakoski inventory" {...input} {...meta} />
              {
                meta.touched && meta.error && (
                  <Message isError>{meta.error}</Message>
                )
              }
            </InputWrapper>
          )}
        </Field>
        <Field name="projectDate">
          {({ input, meta }) => (
            <InputWrapper>
              <label>Project date</label>
              <DatePicker
                {...input}
                {...meta}
              />
              {
                meta.touched && meta.error && (
                  <Message isError>{meta.error}</Message>
                )
              }
            </InputWrapper>
          )}
        </Field>
        <Field name="projectDescription">
          {({ input, meta }) => (
            <InputWrapper>
              <label>Project description</label>
              <TextArea
                placeholder="Regular inventory procedure"
                rows="4"
                {...input}
                {...meta} />
              {
                meta.touched && meta.error && (
                  <Message isError>{meta.error}</Message>
                )
              }
            </InputWrapper>
          )}
        </Field>
      </Content>
    </FormSection>
    <FormSection>
      <SectionLabel>Flight Information</SectionLabel>
      <Content>
      <Field name="location">
          {({ input, meta }) => (
            <InputWrapper>
              <label>Location</label>
              <Select
                id="location"
                options={locations}
                getOptionLabel={(options) => options['name']}
                getOptionValue={(options) => options['id']}
                placeholder="Select location"
                {...input}
                {...meta}
                onChange={value => {
                  input.onChange(value);
                }}
              />
              {
                meta.touched && meta.error && (
                  <Message isError>{meta.error}</Message>
                )
              }
            </InputWrapper>
          )}
        </Field>
        <Field name="drone">
          {({ input, meta }) => (
            <InputWrapper>
              <label>Drone</label>
              <Input type="text" placeholder="DJI Phantom 4 - SN:XXXXXXXXXX" {...input} {...meta} />
              {
                meta.touched && meta.error && (
                  <Message isError>{meta.error}</Message>
                )
              }
            </InputWrapper>
          )}
        </Field>

        <Field name="flightPurpose">
          {({ input, meta }) => (
            <InputWrapper>
              <label>Flight purpose</label>
              <Input type="text" placeholder="Regular inventory procedure" {...input} {...meta} />
              {
                meta.touched && meta.error && (
                  <Message isError>{meta.error}</Message>
                )
              }
            </InputWrapper>
          )}
        </Field>
        <Field name="flightIncident">
          {({ input, meta }) => (
            <InputWrapper>
              <label>Incidents during flight</label>
              <TextArea
                placeholder="None"
                rows="4"
                {...input}
                {...meta} />
              {
                meta.touched && meta.error && (
                  <Message isError>{meta.error}</Message>
                )
              }
            </InputWrapper>
          )}
        </Field>
      </Content>
    </FormSection>
    <FullWidthSection>
      <SectionLabel>Settings</SectionLabel>
      <Content>
        <Field name="calculateDetection" type="checkbox">
          {({ input, meta }) => (
            <CheckBox
              {...input}
              {...meta}
              id="calculateDetection"
              label="Calculate detection"
            />
          )}
        </Field>
        { (selectedType !== "forest") && (
          <>
        <Field name="removeStackingChip" type="checkbox">
          {({ input, meta }) => (
            <CheckBox
              {...input}
              {...meta}
              id="removeStackingChip"
              onChange={e => {
                const checked = e.target.checked;
                if(checked) {
                  change('removeContinuousChip', false);
                }
                input.onChange(e)
              }}
              label="Remove stacking chip conveyor"
            />
          )}
        </Field>
        <Field name="removeContinuousChip" type="checkbox">
          {({ input, meta }) => (
            <CheckBox
              {...input}
              {...meta}
              id="removeContinuousChip"
              onChange={e => {
                const checked = e.target.checked;
                if(checked) {
                  change('removeStackingChip', false);
                }
                input.onChange(e)
              }}
              label="Remove continuous chip conveyor"
            />
          )}
        </Field>
        </>
      )}
      </Content>
    </FullWidthSection>
  </FormWrapper>
  );
}

export default UploadingDrone;